<template>
	<div class="row">
		<img src="../assets/img/caslogo.png" id="img" style="display:none">
		<div class="col-sm-3">
			<card class="card" title="Employee">
				<loader :loading="loading_employees">
					<div class="mb-3">
						<select class="form-control" v-model="department" @change="loadEmployees()">
							<option :value="null">All</option>
							<option  v-for="d in departments" :value="d.id_department" :key="d.id_department">{{d.name}}</option>
						</select>
					</div>
					<div>
						<b-list-group>
							<b-list-group-item  v-for="e in employees" :key="e.id_employee" :active="idEmployee==e.id_employee && idEmployee!=undefined">
								<router-link :to="'/dashboard/'+e.id_employee+'/'+date">
									<b>{{e.first_name+' '+e.last_name}}</b>
									<p>
										<small>{{getDepartment(e.departments)}}</small>
										<br v-if="e.helper!=null">
										<small v-if="e.helper!=null">Default: {{e.helper.first_name+' '+e.helper.last_name}}</small>
										<br v-if="e.helper_today!=null">
										<small v-if="e.helper_today!=null">Today: {{e.helper_today.first_name+' '+e.helper_today.last_name}}</small>
									</p>
								</router-link>
							</b-list-group-item>
						</b-list-group>
					</div>
				</loader>
			</card>
		</div>
		<div class="col-sm-9">
			<div class="row">
				<div class="col-sm-6" v-if="idEmployee!==undefined">
					<card class="card" title="Date">
						<loader :loading="loading_day">
							<form @submit.prevent>
								<div class="row">
									<div class="col-xl-6 col-lg-6">
										<label>Day</label>
										<datepicker monday-first @input="onChangeDate" v-model="date" format="dd/MM/yyyy" input-class="form-control false-disabled"></datepicker>
									</div>
									<div class="col-xl-6 col-lg-6">
										<label>Helper</label>
										<select class="form-control" v-model="$v.day.id_helper_employee.$model">
											<option :value="null">Nobody</option>
											<option  v-for="e in available_helpers" :value="e.id_employee" :key="e.id_employee" v-if="e.enabled==1">
												{{e.first_name+' '+e.last_name}}
												<!--<template v-if="e.used"> - n/a</template>-->
											</option>
										</select>
										<!-- <small v-if="employee.helper!==null">Default: {{employee.helper.first_name+' '+employee.helper.last_name}}</small> -->
									</div>
								</div>
								<div class="row">
									<div class="col-xl-12 col-lg-12">
										<label>Notes</label>
										<textarea v-model="$v.day.note.$model" class="form-control"></textarea>
									</div>
								</div>
								<template name="footer">
									<div class="row">
										<div class="col-12 text-right">
											<p-button v-if="dayIsModified" :loading="loading_save_day" round @click.native.prevent="saveDay" class="btn btn-success btn-sm">Save</p-button>
										</div>
									</div>
								</template>
							</form>
						</loader>
					</card>
				</div>
				<div class="col-sm-6">
					<stats-card v-if="idEmployee">
						<div slot="header">
							<b>{{employee.first_name+' '+employee.last_name}}</b>
							<p>
								<small>{{getDepartment(employee.departments)}}</small>
								<br>{{employee.telephone_number}}
								<br>{{employee.veichle_number}}
							</p>
						</div>
						<div class="numbers" slot="content">
							<loader class="mr-2" right :loading="loading_day || loading_appointments">
							 {{jobs_today}} of {{day.slots!==null ? day.slots : employee.slots}}
							<p>Jobs today</p>
							</loader>
						</div>
						<div class="stats" slot="footer">
							<p-button v-if="!loading_day && !dayIsModified" v-b-modal.add-edit-slots round class="btn btn-danger btn-sm">Change available slots</p-button>
						</div>
					</stats-card>
				</div>
				<div class="col-sm-12" v-if="idEmployee!==undefined">
					<card title="Appointments" :subTitle="'Total: '+(appointments.length).toString()">
						<template slot="command">
							<p-button icon round type="link" :loading="loading_appointments" @click.native.prevent="loadAppointments(idEmployee,$route.params.date)"><i class="ti-reload"></i></p-button>
							<p-button @click.native.prevent="printAll()" round type class="btn btn-sm btn-success" v-if="!loading_appointments && appointments.length>0 && canPrint">Print</p-button>
							<p-button @click.native.prevent="loadAppointment('new')" v-b-modal.add-edit-appointment round class="btn btn-success btn-sm">Add</p-button>
							<p-button @click.native.prevent="loadAppointment('new',true)" v-b-modal.add-edit-appointment round class="btn btn-success btn-sm">New project</p-button>
						</template>
						<div class="row">
							<div class="col-12">
								<b-table id="table-appointments" responsive striped hover
								:items="appointments" :fields="columns_appointments" :busy='loading_appointments' show-empty @row-clicked="myRowClickHandler">
									<template v-slot:table-busy>
										<loader :loading="loading_appointments"></loader>
									</template>
									<template v-slot:cell(id_appointment)="row">
										<!--<p-button @click.native.prevent="loadAppointment(row.item.id_appointment)" v-b-modal.add-edit-appointment round class="btn btn-success btn-sm">Edit</p-button>-->
										{{row.item.id_appointment}}<b-badge v-if="row.item.id_project" pill variant="success">P</b-badge>
									</template>
								</b-table>
							</div>
						</div>
					</card>
				</div>
			</div>
		</div>
		<add-edit-appointment :day="day" :employee="employee" :employees="employees" :appointments="appointments" :status="status" :categories="categories" :client="appointment.client" :appointment="appointment" :loading="loading_appointment"></add-edit-appointment>
		<add-edit-slots :day="day"></add-edit-slots>
	</div>

</template>

<script>

import StatsCard from '../components/Cards/StatsCard';
import Datepicker from 'vuejs-datepicker';
import AddEditAppointment from './Appointment/AddEditAppointment';
import AddEditSlots from './Employee/AddEditSlots';
import {required} from 'vuelidate/lib/validators';
import pdfMake from "pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts"
import {helper_pdf} from '../helper/pdf';

export default {
	components: {
		StatsCard,
		Datepicker,
		AddEditAppointment,
		AddEditSlots
	},
	data() {
		return {
			jobs_today:0,
			appointments_to_show:[],
			departments:[],
			department:null,
			employees:[],
			available_helpers:[],
			filter_employees:[],
			loading_employees:true,
			employee:{},
			clients:[],
			categories:[],
			appointments:[],
			appointment:{},
			status:[],
			loading_appointment:true,
			loading_appointments:true,
			columns_appointments: [
				{
					key: "id_appointment",
					label: "#",
				},
				{
					key: "time",
					label:"Time"
				},
				{
					key: "client",
					label: "Client",
					formatter:(val)=>{
						return val.first_name+' '+val.last_name
					}
				},
				{
					key: 'detail',
					label: 'Detail'
				},
                {
                    key:"address",
                    label:"Address"
				},
				{
					key:"note",
					label:"Note"
				},
				{
					key:'state',
					label:"State",
					formatter:(val)=>{
						return val.name;
					}
				}
			],
			date:this.$route.params.date==undefined ? this.$moment().format('YYYY-MM-DD') : this.$route.params.date,
			day:{},
			loading_day:true,
			loading_save_day:false
		}
	},
	 validations:{
		day:{
			id_helper_employee:{},
			note:{}
	  	}
  	},
	computed:{
		idEmployee(){
			return this.$route.params.id_employee;
		},
		routeDate(){
			return this.$route.params.date;
		},
		dayIsModified(){
			return this.$v.day.$anyDirty;
		},
		canPrint(){
			let found_department = this.employee.departments.find(d=>{
				return d.id_department===2 || d.id_department===4
			});

			let found_printable = this.appointments.find(a=>{
				return a.printable===1
			})

			return !!found_department && !!found_printable;
		}
	},
	methods:{
		myRowClickHandler(record, index){
			this.$router.push({path:'/dashboard/'+this.$route.params.id_employee+'/'+this.$route.params.date+'?app='+record.id_appointment});
		},
		/*employees */
		async loadEmployees(){
			this.loading_employees = true;
			let result = await this.$api.get('employee?where=enabled=1&join=departments,helper');
			this.employees = result.data;
			let date = this.$moment().format('YYYY-MM-DD')
			if(this.routeDate){
				date = this.routeDate
			}
			let result_today = await this.$api.get('day?join=helper_employee&where=date='+date)
			this.employees.forEach(e => {
				let found = result_today.data.find(h=>{
					return e.id_employee === h.id_employee
				})
				if(!!found)
					this.$set(e,'helper_today',found.helper_employee)
				else
					this.$set(e,'helper_today',null)
			});
			if(this.department!==null){
				let found = this.employees.filter(e=>{
					return e.departments.find(d=>{
						return d.id_department == this.department;
					})
				});
				this.employees = found;
			}
			this.loading_employees = false;
		},
		loadEmployee(id_employee){
			let result = this.employees.filter(e=>{
				return e.id_employee == id_employee
			});
			this.employee = result[0];
		},
		async loadHelpers(){
			
		},
		getDepartment(dep=[]){
			let str = '';
			for(let i=0;i<dep.length;i++){
				str+=dep[i].name;
				if(i!==dep.length-1){
					str+=', '
				}
			}
			return str;
		},
		/**days */
		async loadDay(id_employee,date){
			this.loading_day = true;
			let result = await this.$api.get('day?where=date='+date+',id_employee='+id_employee);
			if(result.data.length>0){
				this.day = result.data[0];
			}
			else{
				this.day = {
					id_day:null,
					date:this.$route.params.date,
					note:null,
					slots:null,
					id_helper_employee:null,
					id_employee:this.idEmployee
				}
				this.day.id_helper_employee = this.employee.id_helper_employee
			}
			let result_helper = await this.$api.get('employee?where=id_employee!='+this.idEmployee);
			//let result_availability_helper_day = await this.$api.get('day?fields=id_employee,id_helper_employee&where=date='+date)
			this.available_helpers = result_helper.data;
			/*for(let i=0;i<this.available_helpers.length;i++){
				let found = result_availability_helper_day.data.find(a=>{
					return a.id_helper_employee===this.available_helpers[i].id_employee
				})
			
				if(!!found){
					this.$set(this.available_helpers[i],'used',true)
				}
				else{
					this.$set(this.available_helpers[i],'used',false)
				}
				
			}*/
			this.loading_day = false;
		},
		async saveDay(){
			this.loading_save_day = true;
			if(this.day.id_day===null){
				let result = await this.$api.post('day',this.day);
				this.day.id_day = result.data.id_day;
			}
			else{
				let result = await this.$api.put('day/'+this.day.id_day,this.day);
				let day = result.data;
				if(day.note==null && day.slots==null && day.id_helper_employee==null){
					await this.$api.delete('day/'+day.id_day);
					this.day.id_day = null
				}
			}
			let found_employee = this.employees.find(e=>{
				return e.id_employee==this.day.id_employee
			})
			let found_helper = this.available_helpers.find(h=>{
				return h.id_employee==this.day.id_helper_employee
			})
			found_employee.helper_today = found_helper
			if(found_employee.helper_today==null){
				this.day.id_helper_employee = found_employee.id_helper_employee
			}

			//"id_helper_employee": 14, "id_employee": 11
			this.$toast.success({
				message:'day updated',
				icon: "ti-check"
			});
			this.$v.day.$reset();
			this.loading_save_day = false;
		},
		onChangeDate(){
			this.date = this.$moment(this.date).format('YYYY-MM-DD');
			this.$v.day.$reset();
			this.loadEmployees();
			this.$router.push('/dashboard/'+this.idEmployee+'/'+this.date);
		},
		/**appointment */
		async loadAppointments(id_employee,date){
			this.loading_appointments = true;
			let result = await this.$api.get('appointment?join=client,state&where=id_employee='+id_employee+',date='+date);
			this.appointments = result.data;

			this.jobs_today = result.data.length;
			
			let project = null;
			for ( let i=0;i < this.appointments.length; i++ ){
				if(this.appointments[i].id_project!=null){
					project = this.appointments[i]
				}
			}

			this.appointments = this.appointments.filter(a=>{
				return a.id_project==null
			})

			if(project!=null){
				this.appointments.push(project)
			}
				
			this.loading_appointments = false;
		},
		async loadAppointment(id,project=false){
			this.loading_appointment = true;
            if(id==='new'){
                let result = {
		            data:{
						is_project:project,
						id_project:null,
						_created_at:null,
						date_start:this.$moment().format('YYYY-MM-DD'),
						date_end:this.$moment().add(1,'days').format('YYYY-MM-DD'),
                        id_appointment:null,
                        time:null,
			            id_client:null,
                        address:null,
                        detail:null,
                        reference:null,
						date:this.routeDate,
                        note:null,
						id_category:null,
						id_employee:this.idEmployee,
						id_state:2,
						printable:1
                    }
		        }
		        this.appointment = result.data;
            }
            else{
				let result = await this.$api.get('appointment/'+id+'?join=client');
				this.appointment = result.data
				if(this.appointment.id_project!=null){
					let result = await this.$api.get('appointment?fields=date&where=id_project='+this.appointment.id_project);
					this.$set(this.appointment,'date_start',result.data[0].date);
					this.$set(this.appointment,'date_end',result.data[result.data.length-1].date);
				}
				this.$set(this.appointment,'current_date',this.appointment.date);
				this.$set(this.appointment,'current_id_employee',this.appointment.id_employee);
			}
			await this.loadClients();
			await this.loadCategories();
			await this.loadStatus();
			if(id==='new'){
				this.appointment.id_category = this.categories[0].id_category;
			}
			this.loading_appointment = false;
		},
		async printAll(){
			pdfMake.vfs = pdfFonts.pdfMake.vfs;

			let helper = '';
            if(this.day.id_helper_employee!==null){
                let result = await this.$api.get('employee/'+this.day.id_helper_employee);
                helper = result.data.first_name+' '+result.data.last_name;
			}
			
			//let imgObj = new Image();
			//imgObj.src = require('../assets/img/caslogo.png');
			let imgObj = document.getElementById('img');
            let canvas = document.createElement('canvas');
            canvas.width = imgObj.width; 
            canvas.height = imgObj.height;
            let context = canvas.getContext('2d');
            context.drawImage(imgObj,0,0);

			let content = [];
			for(let i=0;i<this.appointments.length;i++){
				if(this.appointments[i].printable===1){
					if(i!==0){
						content.push({text:'',pageBreak: 'before'});
					}
					let table = helper_pdf.get_structure(canvas.toDataURL('image/png'),this.appointments[i],this.appointments[i].client,this.employee,helper);
					content.push(table);
				}
			}
			
			let pdf = {
				content:content,
				styles: helper_pdf.get_style()
            };

			pdfMake.createPdf(pdf).print();
		},
		/**clients */
		async loadClients(){
            let result = await this.$api.get('client?fields=id_client,first_name,last_name,address,telephone_number');
            this.clients = result.data;
		},
		/**categories */
		async loadCategories(){
			let result = await this.$api.get('category');
            this.categories = result.data;
		},
		/**status */
		async loadStatus(){
			let result = await this.$api.get('state');
			this.status = result.data;
		},
		/**departments */
		async loadDepartments(){
			let result = await this.$api.get('department');
			this.departments = result.data;
		}
	},
	beforeRouteUpdate (to, from, next) {
		let id_employee = to.params.id_employee;
		let date = to.params.date;
		this.$v.day.$reset();
		if(to.params.id_employee!=from.params.id_employee || to.params.date!=from.params.date){
			if(id_employee!==undefined && date!==undefined){
				//this.loadHelpers();
				this.loadEmployee(id_employee);
				this.loadDay(id_employee,date);
				this.loadAppointments(id_employee,date);
			}
		}
		if(to.query.app){
			this.$bvModal.show('add-edit-appointment');
			this.loadAppointment(to.query.app);
		}
		next();
  	},
	async beforeMount(){
		//await this.loadHelpers();
		await this.loadDepartments();
		await this.loadEmployees();
		
		//this.available_helpers = this.employees;
		if(this.idEmployee!==undefined){
			
			await this.loadEmployee(this.idEmployee);
			await this.loadDay(this.idEmployee,this.date);
			await this.loadAppointments(this.idEmployee,this.date);
		}
		if(this.$route.query.app){
			this.$bvModal.show('add-edit-appointment');
			this.loadAppointment(this.$route.query.app);
		}
	}
};
</script>
<style>
	#table-appointments tbody tr:hover{
		background-color: #dedede  !important;
		cursor: pointer;
	}
</style>

